module.exports = "<i *ngIf=\"type === 'text'\">{{ key | translate:param }}</i>\n<i *ngIf=\"type === 'html'\" [innerHTML]=\"key | translate:param\"></i>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/i18n-msg/i18n-msg.component.html
// module id = ./src/app/components/i18n-msg/i18n-msg.component.html
// module chunks = main